import React, { useEffect } from 'react'
import Router, { useRouter } from 'next/router'
import * as gtag from 'helpers/ga'
import 'assets/css/main.css'
import { CartProvider } from 'hooks/use-cart'
import { CartModalProvider } from 'hooks/use-cart-modal'
import { UserSessionProvider } from 'hooks/use-user-session'
import { MercadinhoProvider } from 'hooks/use-mercadinho'
import { ToastProvider } from 'hooks/use-notification'
import { AfiliadoProvider } from 'hooks/use-afiliado'

Router.events.on('routeChangeComplete', (url) => gtag.pageview(url))

export default function ExtendedApp({
  Component,
  pageProps,
}: {
  Component: React.ElementType
  pageProps: any
}): JSX.Element {
  // eslint-disable-next-line react/jsx-props-no-spreading

  const router = useRouter()

  useEffect(() => {
    const env = process.env.NODE_ENV
    if (env === 'production') {
      import('react-facebook-pixel')
        .then((x) => x.default)
        .then((ReactPixel) => {
          ReactPixel.init('1199276616878710')
          ReactPixel.pageView()

          router.events.on('routeChangeComplete', () => {
            ReactPixel.pageView()
          })
        })
    }
  }, [router.events])

  return (
    <ToastProvider>
      <UserSessionProvider>
        <MercadinhoProvider>
          <CartProvider>
            <CartModalProvider>
              <AfiliadoProvider>
                <Component {...pageProps} />
              </AfiliadoProvider>
            </CartModalProvider>
          </CartProvider>
        </MercadinhoProvider>
      </UserSessionProvider>
    </ToastProvider>
  )
}
